export const carouselSlides = [
  'carousel/karuzela0.jpg',
  'carousel/karuzela3.jpg',
  'carousel/karuzela4.jpg',
  'carousel/karuzela5.jpg',
  'carousel/karuzela1.jpg',
  'carousel/karuzela2.jpg',
];